module.exports = __webpack_public_path__ + "img/drops_1248.84d01448.png";